$(document).ready(function () {

  /* ==========================================================================
      GLOBAL
  ========================================================================== */


  //<![CDATA[
    var prolink$ = jQuery;

    prolink$(function () {
      //put footer to bottom if page is not big enough
      (function () {
          prolink$(document).on('ready', function () {
              var $footer = prolink$('#prolinkftr');
              var pageHeight = Math.max(prolink$('html').height(), prolink$('body').height());
              if (typeof $footer !== 'undefined') {
                  var footerHeight = $footer.height();
                  var footerPosition = $footer.offset().top;
                  var windowHeight = prolink$(window).height();
                  if (windowHeight > pageHeight) {
                      var newMargin = pageHeight - (footerPosition + footerHeight);
                      $footer.css('margin-top', Math.floor(newMargin) + 'px');
                  }
              }
          });
      })();
  });
  //]]>

  if (window.navigator.appVersion.match(/Chrome/)) {
    prolink$(function () {
        prolink$('object').css('zoom', 1);
    });
  }

    $(".addFavorite").on("click",function(d){
        data=$(this).attr("rel").split("-");
        if(data.length==2){
            b(data[0],data[1]);
            $(this).hide("slow");
            $(this).parent().find(".odebrat").show("slow")
        } else {
            console.error("Data for addFavourite() problem")
        }
    });


    $(".removeFavorite").on("click", function (d) { 
        data = $(this).attr("rel").split("-"); 
        if (data.length == 2) { 
            a(data[0], data[1]); 
            $(this).hide("slow"); 
            $(this).parent().find(".pridat").show("slow") 
        } else { 
            console.error("Data for addFavourite() problem") 
        } 
    }); 
    function b(f, e) { 
        var d = "/ajax/users/ajax/add-favourite-item"; 
        $.ajax({ url: d, type: "POST", data: "id=" + f + "&type=" + e, success: function (g) { } }) 
    } 
    function a(f, e) { 
        var d = "/ajax/users/ajax/remove-favourite-item"; 
        $.ajax({ url: d, type: "POST", data: "id=" + f + "&type=" + e, success: function (g) { } }) 
    }

    // Cookie via jQuery
    $(".show-jquery-cookie").click(function(){
        $(".cookie-bar__bg").addClass("cookie-bar__bg--visible");
    });

    $("#cookie-accept").click(function(){
        $(".cookie-bar__bg").removeClass("cookie-bar__bg--visible");
    });

    $("#cookie-setup").click(function(){
        $(".cookie-bar__content").hide();
        $(".cookie-bar__setup").show();
    });

    $("#cookie-agree").click(function(){
        $(".cookie-bar__bg").removeClass("cookie-bar__bg--visible");
        $(".cookie-bar__setup").hide();
        $(".cookie-bar__content").show();
    });

    $("#cookie-cancel").click(function(){
        $(".cookie-bar__setup").hide();
        $(".cookie-bar__content").show();
    });

    $("#cookie-close").click(function(){
        $(".cookie-bar__setup").hide();
        $(".cookie-bar__content").show();
    });
 
}); 